/* ===================== KanpoNow AutoLink (Ingredients-safe) ===================== */
(function(){
  'use strict';

  /* ---------- config from theme ---------- */
  const KEYWORDS_TEXT = window.KN_KEYWORDS_TEXT || '';
  const MAX_PER_WORD  = Number(window.KN_MAX_LINKS_PER_WORD || 0) || 0; // 0=unlimited
  const SCOPE_SELECTORS = (window.KN_SCOPE_SELECTORS || '.rte, main');
  const EXCLUDE_SELECTORS = (window.KN_EXCLUDE_SELECTORS || '[data-kn-autolink="off"], nav, .toc, .breadcrumbs');

  /* ---------- utils ---------- */
  function parseKeywordList(text){
    const list=[]; if(!text) return list;
    for(const raw of text.split(/\r?\n/)){
      const line = raw.trim();
      if(!line || line.startsWith('#')) continue;
      const i = line.indexOf(':') >= 0 ? line.indexOf(':') : line.indexOf('：');
      if(i < 0) continue;
      const left = line.slice(0,i).trim();
      const url  = line.slice(i+1).trim();
      if(!left || !url) continue;
      const variants = left.split(/[，,]/).map(s => s.trim()).filter(Boolean);
      for(const word of variants){ list.push({ word, url }); }
    }
    return list;
  }
  function escapeRegExp(s){ return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }
  function normPath(u){
    try{
      const a=new URL(u,location.origin);
      let p=a.pathname; if(p.length>1 && p.endsWith('/')) p=p.slice(0,-1);
      return p||'/';
    }catch(_){
      let p=String(u||'').split('#')[0].split('?')[0];
      if(!p.startsWith('/')) p='/'+p;
      if(p.length>1 && p.endsWith('/')) p=p.slice(0,-1);
      return p||'/';
    }
  }
  function isExcluded(node){
    if(!node) return true;
    const el = node.nodeType === 1 ? node : node.parentElement;
    if(!el) return true;
    if(el.closest && el.closest(EXCLUDE_SELECTORS)) return true;
    if(el.closest && el.closest('a, script, style, noscript, code, pre')) return true;
    return false;
  }

  /* ---------- core: linkify a text node (no boundary restriction) ---------- */
  // ※成分（生薬）で確実にリンク化するため、境界判定はしない（誤爆はMAX_PER_WORDで抑える）
  function linkifyTextNodeNoBoundary(textNode, word, url, remain){
    if(remain <= 0) return 0;
    const text = textNode.nodeValue;
    if(!text || text.indexOf(word) === -1) return 0;

    const re = new RegExp(escapeRegExp(word), 'g');
    const frag = document.createDocumentFragment();

    let last = 0;
    let made = 0;
    let m;

    while((m = re.exec(text)) !== null){
      if(made >= remain) break;

      const start = m.index;
      const end   = start + word.length;

      if(start > last) frag.appendChild(document.createTextNode(text.slice(last, start)));

      const a = document.createElement('a');
      a.href = url;
      a.textContent = word;
      frag.appendChild(a);

      made++;
      last = end;
    }

    if(made === 0) return 0;
    if(last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));

    textNode.parentNode.replaceChild(frag, textNode);
    return made;
  }

  function collectTextNodes(root){
    const nodes=[];
    const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(n){
        if(!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        if(isExcluded(n)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    while(w.nextNode()) nodes.push(w.currentNode);
    return nodes;
  }

  /* ---------- generic autolink (safe) ---------- */
  function autolinkGeneric(roots, entries){
    // count existing exact-text links per word
    const counters = new Map();
    for(const {word} of entries){
      let c = 0;
      for(const r of roots){
        r.querySelectorAll('a[href]').forEach(a=>{
          const t = (a.textContent || '').trim();
          if(t === word) c++;
        });
      }
      if(c) counters.set(word, c);
    }

    // long words first
    const sorted = entries.slice().sort((a,b)=>b.word.length - a.word.length);

    for(const r of roots){
      for(const {word, url} of sorted){
        const already = counters.get(word) || 0;
        const limit = MAX_PER_WORD ? Math.max(0, MAX_PER_WORD - already) : Infinity;
        if(!limit) continue;

        const nodes = collectTextNodes(r);
        let madeTotal = 0;

        for(const n of nodes){
          if(!n.parentNode) continue;
          const remain = (limit === Infinity) ? Infinity : Math.max(0, limit - madeTotal);
          if(!remain) break;

          const made = linkifyTextNodeNoBoundary(n, word, url, remain);
          if(made) madeTotal += made;

          if(limit !== Infinity && madeTotal >= limit) break;
        }

        if(madeTotal) counters.set(word, already + madeTotal);
      }
    }
  }

  /* ---------- ingredients fail-safe: h3「成分（生薬）」直後のブロックだけ確実にリンク ---------- */
  function autolinkIngredientsFailsafe(entries){
    const map = new Map(entries.map(e=>[e.word, e.url]));
    const targets = Array.from(document.querySelectorAll('.rte h3, .rte h2, .rte h4'));

    for(const h of targets){
      const title = (h.textContent || '').replace(/\s+/g,'').trim();
      if(title !== '成分（生薬）') continue;

      // 直後の要素（pやul）を次の見出しまで拾う
      let el = h.nextElementSibling;
      while(el){
        if(/H2|H3|H4|H5|H6/.test(el.tagName)) break;
        if(!isExcluded(el)){
          // このブロック内だけ “確実” にリンク化
          const nodes = collectTextNodes(el);
          for(const n of nodes){
            if(!n.parentNode) continue;
            const txt = n.nodeValue;
            if(!txt) continue;

            // entriesの長い順で一気に複数語いれる
            const sorted = entries.slice().sort((a,b)=>b.word.length - a.word.length);

            // 1ノードを何回も置換するので、ノードが消える可能性あり → その場合はbreak
            for(const {word, url} of sorted){
              if(!txt.includes(word)) continue;
              if(!n.parentNode) break;
              // 成分欄は確実優先なので MAX_PER_WORD はここでは無視しないが、
              // 全体設定が 1 のときでも「成分に出た分」は絶対リンクにしたい → remain=99
              linkifyTextNodeNoBoundary(n, word, url, 99);
            }
          }
        }
        el = el.nextElementSibling;
      }
      return; // 1箇所で十分
    }
  }

  /* ---------- run ---------- */
  function run(){
    try{
      const all = parseKeywordList(KEYWORDS_TEXT);
      const here = normPath(location.href);
      const entries = all.filter(({url})=>normPath(url)!==here);

      // scope roots
      const roots=[];
      document.querySelectorAll(SCOPE_SELECTORS).forEach(el=>{
        if(!el) return;
        if(el.closest && el.closest(EXCLUDE_SELECTORS)) return;
        roots.push(el);
      });
      if(!roots.length) roots.push(document.body);

      autolinkGeneric(roots, entries);

      // 仕上げ：成分（生薬）だけは絶対に落とさない
      autolinkIngredientsFailsafe(entries);

    }catch(e){
      // 何かあってもページを壊さない
      console.warn('[KanpoNow autolink] error', e);
    }
  }

  // DOMが描画されるタイミング差を吸収（Dawn対策）
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);

  // 遅延で差し込まれた場合も拾う（短時間だけ）
  try{
    const mo = new MutationObserver(()=>{
      if(document.querySelector('.rte')) run();
    });
    mo.observe(document.documentElement, {childList:true, subtree:true});
    setTimeout(()=>{ try{ mo.disconnect(); }catch(_){} }, 5000);
  }catch(_){}
})();